import type { InstrumentDialogState, InstrumentDraft, ProviderInstrumentRow } from './types';
import type { Instant } from '@js-joda/core';
import type { ProviderInstruments } from 'src/admin/LAB/contracts/providers';

export type ProviderInstrumentsAction =
    | {
          type: 'SET_PROVIDER';
          providerId: string | null;
          instruments: ProviderInstruments;
          /** Lets the reducer judge stored end times the way the dialog pre-fill does. */
          now: Instant;
      }
    | { type: 'OPEN_DIALOG'; dialog: InstrumentDialogState }
    | { type: 'CLOSE_DIALOG' }
    | { type: 'PATCH_DRAFT'; patch: Partial<InstrumentDraft> }
    | { type: 'SET_DIALOG_STEP'; step: InstrumentDialogState['step'] }
    | { type: 'START_SAVE'; token: number }
    | { type: 'FAIL_SAVE'; token: number; message: string }
    | { type: 'FINISH_SAVE'; token: number; instruments: ProviderInstruments }
    | { type: 'REQUEST_REMOVE'; entry: ProviderInstrumentRow; token: number }
    | { type: 'CANCEL_REMOVE' }
    | { type: 'START_REMOVE' }
    | { type: 'FAIL_REMOVE'; token: number; message: string }
    | { type: 'FINISH_REMOVE'; token: number; instruments: ProviderInstruments };

export const setProvider = (
    providerId: string | null,
    instruments: ProviderInstruments,
    now: Instant,
): ProviderInstrumentsAction => ({
    type: 'SET_PROVIDER',
    providerId,
    instruments,
    now,
});
export const openDialog = (dialog: InstrumentDialogState): ProviderInstrumentsAction => ({
    type: 'OPEN_DIALOG',
    dialog,
});
export const closeDialog = (): ProviderInstrumentsAction => ({
    type: 'CLOSE_DIALOG',
});
export const patchDraft = (patch: Partial<InstrumentDraft>): ProviderInstrumentsAction => ({
    type: 'PATCH_DRAFT',
    patch,
});
export const setDialogStep = (step: InstrumentDialogState['step']): ProviderInstrumentsAction => ({
    type: 'SET_DIALOG_STEP',
    step,
});
export const startSave = (token: number): ProviderInstrumentsAction => ({ type: 'START_SAVE', token });
export const failSave = (token: number, message: string): ProviderInstrumentsAction => ({
    type: 'FAIL_SAVE',
    token,
    message,
});
export const finishSave = (token: number, instruments: ProviderInstruments): ProviderInstrumentsAction => ({
    type: 'FINISH_SAVE',
    token,
    instruments,
});
export const requestRemove = (entry: ProviderInstrumentRow, token: number): ProviderInstrumentsAction => ({
    type: 'REQUEST_REMOVE',
    entry,
    token,
});
export const cancelRemove = (): ProviderInstrumentsAction => ({
    type: 'CANCEL_REMOVE',
});
export const startRemove = (): ProviderInstrumentsAction => ({
    type: 'START_REMOVE',
});
export const failRemove = (token: number, message: string): ProviderInstrumentsAction => ({
    type: 'FAIL_REMOVE',
    token,
    message,
});
export const finishRemove = (token: number, instruments: ProviderInstruments): ProviderInstrumentsAction => ({
    type: 'FINISH_REMOVE',
    token,
    instruments,
});
